import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

export interface TermsOfUseDialogData {
  termsPageUrl: string;
}

@Component({
  selector: 'portal-terms-of-use-dialog',
  templateUrl: './terms-of-use-dialog.component.html',
  styleUrl: './terms-of-use-dialog.component.scss',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatCheckboxModule, MatIconModule, ReactiveFormsModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TermsOfUseDialogComponent {
  readonly confirmed = new FormControl(false);

  constructor(
    public readonly dialogRef: MatDialogRef<TermsOfUseDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: TermsOfUseDialogData,
  ) {}

  decline(): void {
    this.dialogRef.close(false);
  }

  accept(): void {
    this.dialogRef.close(true);
  }
}
